import { z } from "zod";

/**
 * cascade-refund DTO (US-E15.F4-0179-S02 · @UC9220, @gate money — tiền = string BigInt).
 *
 * Hoàn tiền dây chuyền cho 1 khoản chi: NCC hoàn 1 phần/toàn bộ → phân bổ lại cho những người ĐÃ
 * THỰC GÁNH. `.strict()` — không cho field lạ. Tiền là string số nguyên dương (BigInt an toàn, no-float).
 */

/** Số tiền minor units dạng string nguyên KHÔNG âm (BigInt-safe, no-float). */
const MONEY_INTEGER_STRING_PATTERN = /^\d+$/;
/** Số tiền > 0 (loại "0"). */
const MONEY_POSITIVE_STRING_PATTERN = /^(?!0+$)\d+$/;

/** POST /v1/funds/:fundId/expenses/:expenseId/cascade-refund — body. */
export const cascadeRefundSchema = z
  .object({
    /** Số hoàn (minor units) > 0, ≤ tổng đã gánh (validate ngặt ở service → 422). */
    refundMinor: z.string().regex(MONEY_POSITIVE_STRING_PATTERN),
    idempotencyKey: z.string().min(1).max(200),
    reason: z.string().min(1).max(500),
  })
  .strict();

export type CascadeRefundRequest = z.infer<typeof cascadeRefundSchema>;

/** 1 phần hoàn phân bổ cho 1 người đã gánh. */
export const cascadeRefundAllocationSchema = z
  .object({
    memberId: z.string().uuid(),
    refundMinor: z.string().regex(MONEY_INTEGER_STRING_PATTERN),
  })
  .strict();

export type CascadeRefundAllocation = z.infer<typeof cascadeRefundAllocationSchema>;

export const cascadeRefundResponseSchema = z
  .object({
    /** txId bút toán hoàn (REVERSAL cho full, REFUND balanced cho partial). */
    reversalTxId: z.string().uuid(),
    allocations: z.array(cascadeRefundAllocationSchema),
    currency: z.string().length(3),
    refundedAt: z.string().datetime(),
  })
  .strict();

export type CascadeRefundResponse = z.infer<typeof cascadeRefundResponseSchema>;
